import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'



import store from '../store/'
import axios from '../request'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})
const AppId = 'wxda773f5504e277d6' // 幼高专appId

// console.log('正式环境换成这个以/auth的前缀');


// 微信公众号登录
function getUserInfo(code) {
  return axios.post('/auth/api/autoLogin', {
    code,
    appId: 'wxda773f5504e277d6',
  })
}

// 判断当前浏览器
let u = navigator.userAgent;
let isAndroid = u.indexOf() > -1 || u.indexOf('Adr') > -1


// 关闭公众号网页方法
function closeWebpage() {
  console.log('判断当前手机型号', isAndroid)
  document.addEventListener("WeixinJSBridgeReady", function () {
    WeixinJSBridge.call("closeWindow");
  }, false)
}

// 测试环境使用
// function getUserInfo(code) {
//   return axios({url:'http://192.168.10.250:8061/api/autoLogin',data:{code,appId:store.state.appId},method:'post'})
// }
//正式环境使用 /auth 这个


// 获取用户信息
function getNewUserInfo(openId) {
  return axios.get(`/auth/api/getUserTokenVMByOpenId?openId=${openId}`)
}

// 企业微信获取用户信息
function getQyNewUserInfo(wxCpUserId) {
  return axios.get(`/auth/api/getUserTokenByWxCpUserId?wxCpUserId=${wxCpUserId}`)
}


// 企业微信登录
function getQyUserInfo(code, id) {
  return axios.post(`/auth/wx/cp/${id}/login`, {
    code
  })
}
//测试环境使用
// function getNewUserInfo(openId) {
//   return axios({url:`http://192.168.10.250:8061/api/getUserTokenVMByOpenId?openId=${openId}`,data:{},method:'post'})
// }


let state = '123'
let redirectURL = encodeURIComponent(window.location.href) //重定向地址

// 微信跳转基础地址
let base = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=`

// 统一服务认证平台地址
let baseCas = 'https://sso.jnpec.edu.cn/login?service=' //
//  统一服务认证平台地址 测试地址
// let baseCas = 'http://192.168.10.40:8443/cas/login?service=' //


// 获取路径后参数
function getQueryVariable(variable) {
  var query = window.location.search.substring(1)
  console.log('我是query');
  console.log(query);
  var vars = query.split('&')
  let arr = []
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] == variable) {
      arr.push(pair[1])
    }
  }

  if (arr.length) {
    return arr[arr.length - 1]
  } else {
    return undefined
  }
}


// 白名单 （无需登录）
const whiteList = [
  // '/subscribe',
  '/leaveDetail',
  '/enterDetail',
  '/approvalNoticeDetail',
  '/noticeDetail',
  "/alarmMessage", // 报警明细
  '/qcode',
  '/achievementDetail',
  '/achievement',
  '/casLogin',
]


// 活动室相关页面
const roomList = [
  // 活动室预约页面开始
  '/roomAppointment', // 活动室预约 ( 学生 )
  '/roomReservation', // 个人 / 团体预约 ( 学生)
  '/roomApproval', //活动室审批列表 (老师 )
  '/roomReservationDetail', // 活动室预约详情 ( 学生 )
  '/roomApprovalDetail', // 活动室审批详情 （ 老师 ）
  '/roomAppointRecord', // 活动室预约记录  （学生）
  // 活动室预约页面结束
]


// 活动室学生页面
const roomStudentList = [
  '/roomAppointment', // 活动室预约 
  '/roomReservation', // 个人 / 团体预约 ( 学生)
  '/roomReservationDetail', // 活动室预约详情 ( 学生 )
  '/roomAppointRecord' // 活动室预约记录  （学生）
]
// 活动室老师页面
const roomTeacherList = [
  '/roomAppointment', // 活动室预约 
  '/roomReservation', // 个人 / 团体预约 ( 老师)
  '/roomApproval', // 活动室审批列表 (老师 )
  '/roomReservationDetail',//  活动室预约详情  （老师）
  '/roomAppointRecord', // 活动室预约记录  （老师）
  '/roomApprovalDetail', // 活动室审批详情 （ 老师 ）
]





// 根据角色分配不同的首页
function redirectRouter(type) {
  let obj = {
    13: { path: '/approval', replace: true },
    2: { path: '/visitor', replace: true },
    12: { path: '/Attendance', replace: true },
  }
  return obj[type]
}


// 处理appId
function handleAppId() {
  const appId = getQueryVariable('appId')
  if (appId) {
    localStorage.setItem('appId', 'wxda773f5504e277d6')
  }
  return appId
}

// 处理邀约学校id
function handleSchoolId(to) {
  const schoolId = getQueryVariable('schoolId')
  // if (!sessionStorage.getItem('schoolId')) {
  //   store.commit('setSchoolId', schoolId)
  // }
  // 存在schoolId,保存
  if (schoolId && to.path === '/subscribe') {
    sessionStorage.setItem('subschoolId', schoolId)
  }
}

// 权限重定向
function routerPageRulesPath(path) {
  const teacherRoutesPath = [
    '/teacherAttendance',
    '/classesAttendance',
    '/teacherLeaveForm',
    '/approval',
  ]
  const studentRoutesPath = [
    '/leaveForm',
    '/studentAttendance',
    '/pickupForm',
    '/openVip',
  ] // 家长菜单集合
  const userInfo = JSON.parse(localStorage.getItem('userInfo'))
  const redirectPath = '/profile'
  // 家长
  if (studentRoutesPath.indexOf(path) > -1) {
    if (userInfo.patriarchSchoolId && userInfo.patriarchUserId) {
      return studentRoutesPath[studentRoutesPath.indexOf(path)]
    } else {
      return redirectPath
    }
  }
  // 老师
  if (teacherRoutesPath.indexOf(path) > -1) {
    if (userInfo.id && userInfo.schoolId) {
      return teacherRoutesPath[teacherRoutesPath.indexOf(path)]
    } else {
      return redirectPath
    }
  }
  // 访客
  return null
  // callback()
}



// 企业访客相关页面路由
const enterPriseVisitor = [
  '/subscribeQy', '/approvalQy', '/visited-historyQy', '/visNoticeDetailQy', '/detailSubQy', '/approvalNoticeDetailQy'
]

// 判断是否是苹果手机
const isIos = function () {
  const u = navigator.userAgent
  return u.indexOf("iPhone") > -1 || u.indexOf("Mac Os") > -1
}




// 路由跳转管理
router.beforeEach(async (to, from, next) => {
  // 邀约扫码，保存他人的学校id，
  if (to.path === '/subscribe') {

    sessionStorage.setItem('subpath', to.path)
  }
  // 判断是企业微信环境还是微信环境
  let ua = navigator.userAgent.toLowerCase() // 获取标识

  // 判断当前所处的浏览器环境
  let isWx = /micromessenger/i.test(ua) && !/wxwork/i.test(ua)// 是否是微信浏览器环境
  let isComWx = /micromessenger/i.test(ua) && /wxwork/i.test(ua) // 是否是企业微信浏览器环境
  const appId = handleAppId() // 获取微信或企业微信的appId
  handleSchoolId(to)
  let schoolId = getQueryVariable('schoolId')

  document.title = `${to.meta.title}`
  sessionStorage.setItem("qrcodeSchoolId", schoolId);

  const userInfo = localStorage.getItem('userInfo')  // 获取本地保存的用户数据  
  // 注册路径 
  if (to.path === '/register') {
    next()
    return
  }

  // 判断路径执行 (白名单路径 ， 活动室预约路径 )
  if (whiteList.includes(to.path)) { // 白名单路径
    next()
  } else if (roomList.includes(to.path)) {
    // 判断当前是否存在cas登录token
    let casToken = localStorage.getItem('cas_token')
    let casUserInfo = localStorage.getItem('cas_userInfo')

    if (casToken && casUserInfo) {


     
      // 老师权限处理
      if (JSON.parse(casUserInfo).personType == 13) {
        if (roomTeacherList.indexOf(to.path) > -1) {
          next()
        } else {
          // 老师禁入
          console.log('老师禁入')
          closeWebpage()
        }
      }

      // // 学生权限处理
      if (JSON.parse(casUserInfo).personType == 11) {
        if (roomStudentList.indexOf(to.path) > -1) {
          next()
        } else {
          console.log('学生禁入')
          closeWebpage()
        }
      }
    } else {
      // window.location.href = baseCas + 'http://lvyushui.frp.asiait.net/casLogin' // 测试
      window.location.href = baseCas + 'https://sca.jnpec.edu.cn/mobile/casLogin'

    }

  } else {
    // 微信环境登录

    if (isWx) {
      // 微信获取用户信息处理方法
      if (userInfo && !enterPriseVisitor.includes(to.path) && to.path != '/profileQy') {
        // 判断当前进入的路由
        // 执行微信公众号逻辑
        const opneId = localStorage.getItem('openId')
        const res = await getNewUserInfo(opneId)
        console.log('-------获取信息------', res)

        const info = res.data

        if (res.code == 200) {
          store.commit('setUserId', info.id)
          store.commit('setSchoolId', info.schoolId)
          store.commit('setpId', {
            id: info.patriarchUserId,
            schoolId: info.patriarchSchoolId,
          })
          localStorage.setItem('openId', info.openId)
          localStorage.setItem(
            'userInfo',
            JSON.stringify({
              ...JSON.parse(localStorage.getItem('userInfo')),
              ...info,
            })
          )
        } else {
          // localStorage.clear()
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          Vue.prototype.$toast('获取信息失败，请重新登录')
          return
        }

        // store.commit('setpId', {
        //   id: JSON.parse(localStorage.getItem('userInfo')).patriarchUserId,
        //   schoolId: JSON.parse(localStorage.getItem('userInfo'))
        //     .patriarchSchoolId,
        // })
        const teacherRoutesPath = [
          '/teacherAttendance',
          '/classesAttendance',
          '/teacherLeaveForm',
          '/approval',
          '/schoolTeacher'
        ]
        const studentRoutesPath = [
          '/leaveForm',
          '/studentAttendance',
          '/pickupForm',
          '/openVip',
        ] // 家长菜单集合
        const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        const redirectPath = '/profile'
        // 家长
        if (studentRoutesPath.indexOf(to.path) > -1) {
          console.log('家长的进来了');
          if (userInfo.patriarchSchoolId && userInfo.patriarchUserId) {
            return next()
          } else {
            return next({ path: '/fullscreen' })
          }
        }
        // 老师
        if (teacherRoutesPath.indexOf(to.path) > -1) {
          console.log('老师的进来了');

          if (userInfo.id && userInfo.schoolId) {
            return next()
          } else {
            return next({ path: '/fullscreen' })
          }
        }
        if (['/schoolList', '/notice-setting'].includes(to.path)) {
          if (
            (userInfo.patriarchSchoolId && userInfo.patriarchUserId) ||
            (userInfo.id && userInfo.schoolId) ||
            userInfo.visitorUserId
          ) {
            return next()
          } else {
            return next({ path: '/fullscreen' })
          }
        }

        return next()
      }


      // 判断当前是否是访客页面 ( userInfo不存在并且当前待跳转路是 企业微信访客系统 跳转至个人信息页面)
      if (!userInfo && enterPriseVisitor.includes(to.path)) {
        // 判断是否存在过期标识
        if (!localStorage.getItem('tokenFailure')) {
          next({ path: '/profileQy' })
          return
        }
      }
      // 获取code
      const code = getQueryVariable('code')


      // 当前是个人信息页面 或 是企业访客系统 && 无用户信息
      if ((to.path === '/profileQy' || enterPriseVisitor.includes(to.path)) && !userInfo) {
        // 判断当前页面是否是一级页面
        if (from.path == '/') {
          const code = getQueryVariable('code')
          if (!code) {


            window.location.href = base +
              'wxe2baff2ecd3b76ae' +
              `&redirect_uri=` +
              redirectURL +
              `&response_type=code&scope=snsapi_base&state=qiye&agentId=${1000043}#wechat_redirect`


          } else if (code && getQueryVariable('state') == 'qiye') {
            window.location.href =
              base +
              'wxda773f5504e277d6' +
              `&redirect_uri=` +
              redirectURL +
              `&response_type=code&scope=snsapi_base&state=${code}#wechat_redirect`

          } else {

            localStorage.setItem('code', code)

            // try {
            // const res = await getUserInfo(code)

            const res = await getQyUserInfo(getQueryVariable('state'), 1000043)


            if (res.code === 200 && res.data && res.data.token) {
              res.data.personType = res.data.personType || 2
              localStorage.setItem('userInfo', JSON.stringify(res.data))
              localStorage.setItem('wxCom_token', res.data.token)
              // 保存用户Id字段
              localStorage.setItem('wxCpUserId', res.data.openId)
              localStorage.setItem('appId', 'wxda773f5504e277d6')
              localStorage.removeItem('tolenFailure')
              store.commit('setAppId', 'wxda773f5504e277d6')
              store.commit('setUserId', res.data.loginId)
              store.commit('setSchoolId', res.data.schoolId)
              store.commit('setpId', {
                id: res.data.patriarchUserId,
                schoolId: res.data.patriarchSchoolId,
              })

              // 老师路由集合
              const teacherRoutesPath = [
                '/teacherAttendance',
                '/classesAttendance',
                '/teacherLeaveForm',
                '/approval',
                '/schoolList',
                '/notice-setting',
              ]
              // 学生路由集合
              const studentRoutesPath = [
                '/leaveForm',
                '/studentAttendance',
                '/pickupForm',
                '/openVip',
                '/schoolList',
                '/notice-setting',
              ] // 家长菜单集合
              const userInfo = JSON.parse(localStorage.getItem('userInfo'))
              const redirectPath = '/profile'
              // 家长
              if (studentRoutesPath.indexOf(to.path) > -1) {
                if (userInfo.patriarchSchoolId && userInfo.patriarchUserId) {


                  return next()
                } else {
                  return next({ path: '/fullscreen' })
                }
              } else if (teacherRoutesPath.indexOf(to.path) > -1) {
                // 正式环境使用这个判断
                if (userInfo.personType == 13 && userInfo.schoolId) {
                  return next()
                } else {
                  return next({ path: '/fullscreen' })
                }
              } else {
                return next()
              }

              // const p = routerPageRulesPath(to.path)
              // console.log('未登录跳转的目录', p)
              // if (p) {
              //   // Vue.prototype.$toast('您没有该身份')
              //   return next({ path: p, replace: true })
              // } else {
              //   next()
              // }
              // next(redirectRouter(res.data.personType))
            } else if (res.code == '413' && res.msg == '用户未绑定账号') {

              // 清空本地存储
              localStorage.clear()
              // 保存用户名至本地
              localStorage.setItem('wxCpUserId', res.data)

              // 当前在用户信息页面 , 不进行跳转
              if (to.path == '/profileQy') {
                next()
                return
              } else if (enterPriseVisitor.includes(to.path)) {
                // 跳转至用户信息页面进行登录
                next({ path: '/profileQy' })
                return
              }


            }
          }

        } else {
          // 老师路由集合
          const teacherRoutesPath = [
            '/teacherAttendance',
            '/classesAttendance',
            '/teacherLeaveForm',
            '/approval',
            '/schoolList',
            '/notice-setting',
          ]
          // 学生路由集合
          const studentRoutesPath = [
            '/leaveForm',
            '/studentAttendance',
            '/pickupForm',
            '/openVip',
            '/schoolList',
            '/notice-setting',
          ] // 家长菜单集合
          const userInfo = JSON.parse(localStorage.getItem('userInfo'))
          const redirectPath = '/profile'
          // 家长
          if (studentRoutesPath.indexOf(to.path) > -1) {
            if (userInfo.patriarchSchoolId && userInfo.patriarchUserId) {


              return next()
            } else {
              return next({ path: '/fullscreen' })
            }
          } else if (teacherRoutesPath.indexOf(to.path) > -1) {
            // 正式环境使用这个判断
            if (userInfo.personType == 13 && userInfo.schoolId) {
              return next()
            } else {
              return next({ path: '/fullscreen' })
            }
          } else {
            return next()
          }
        }
        return
      }





      // 当前是个人信息页面,或是企业访客系统 && 存在用户信息
      if ((to.path === '/profileQy' || enterPriseVisitor.includes(to.path)) && userInfo) {
        const wxCpUserId = localStorage.getItem('wxCpUserId')

        // 调用企业用户登录
        const res = await getQyNewUserInfo(wxCpUserId)
        const info = res.data

        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify({
            ...JSON.parse(localStorage.getItem('userName')),
            ...info
          }))
        } else {
          // 移出userInfo 和 token 添加token过期标记
          localStorage.removeItem('userInfo')
          localStorage.removeItem('wxCom_token')
          localStorage.setItem('tokenFailure', 'tokenFailure') // token失效标记 

          Vue.prototype.$toast('获取信息失败，请重新登录')
          return
        }


        // 老师路由集合
        const teacherRoutesPath = [
          '/teacherAttendance',
          '/classesAttendance',
          '/teacherLeaveForm',
          '/approval',
          '/schoolList',
          '/notice-setting',
        ]
        // 学生路由集合
        const studentRoutesPath = [
          '/leaveForm',
          '/studentAttendance',
          '/pickupForm',
          '/openVip',
          '/schoolList',
          '/notice-setting',
        ] // 家长菜单集合
        const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        const redirectPath = '/profile'
        // 家长
        if (studentRoutesPath.indexOf(to.path) > -1) {
          if (userInfo.patriarchSchoolId && userInfo.patriarchUserId) {


            return next()
          } else {
            return next({ path: '/fullscreen' })
          }
        } else if (teacherRoutesPath.indexOf(to.path) > -1) {
          // 正式环境使用这个判断
          if (userInfo.personType == 13 && userInfo.schoolId) {
            return next()
          } else {
            return next({ path: '/fullscreen' })
          }
        } else {
          return next()
        }
        return
      }





      // 微信公众号重定向处理流程
      if (!code) {
        console.log('新版登录重定向')
        window.location.href =
          base +
          appId +
          `&redirect_uri=` +
          redirectURL +
          `&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`


      } else {


        localStorage.setItem('code', code)
        // try {

        const res = await getUserInfo(code)

        if (res.code === 200 && res.data && res.data.token) {
          console.log('成功了');
          // return false;  
          res.data.personType = res.data.personType || 2
          localStorage.setItem('userInfo', JSON.stringify(res.data))
          localStorage.setItem('token', res.data.token)
          localStorage.setItem('appId', 'wxda773f5504e277d6')
          localStorage.setItem('openId', res.data.openId)
          store.commit('setAppId', 'wxda773f5504e277d6')
          store.commit('setUserId', res.data.id)
          store.commit('setSchoolId', res.data.schoolId)
          store.commit('setpId', {
            id: res.data.patriarchUserId,
            schoolId: res.data.patriarchSchoolId,
          })
          const teacherRoutesPath = [
            '/teacherAttendance',
            '/classesAttendance',
            '/teacherLeaveForm',
            '/approval',
            '/schoolList',
            '/notice-setting',
          ]
          const studentRoutesPath = [
            '/leaveForm',
            '/studentAttendance',
            '/pickupForm',
            '/openVip',
            '/schoolList',
            '/notice-setting',
          ] // 家长菜单集合
          const userInfo = JSON.parse(localStorage.getItem('userInfo'))
          const redirectPath = '/profile'
          // 家长
          if (studentRoutesPath.indexOf(to.path) > -1) {
            if (userInfo.patriarchSchoolId && userInfo.patriarchUserId) {
              return next()
            } else {
              return next({ path: '/fullscreen' })
            }
          } else if (teacherRoutesPath.indexOf(to.path) > -1) {
            // 老师 
            // 正式环境使用这个判断
            if (userInfo.id && userInfo.schoolId) {
              return next()
            } else {
              return next({ path: '/fullscreen' })
            }
          } else {
            return next()
          }
          // const p = routerPageRulesPath(to.path)
          // console.log('未登录跳转的目录', p)
          // if (p) {
          //   // Vue.prototype.$toast('您没有该身份')
          //   return next({ path: p, replace: true })
          // } else {
          //   next()
          // }
          // next(redirectRouter(res.data.personType))
        } else {
          console.log('进入错误信息位置了');

          // next({ path: '/register', replace: true })
          next({ path: '/profile', replace: true })
        }
        // } catch (error) {
        //   next({ path: '/profile', replace: true })
        // }
      }








    } else if (isComWx) { // 企业微信处理逻辑




      if (!userInfo && enterPriseVisitor.includes(to.path)) { // 无userInfo 并且处于企业微信访客系统 跳转至个人信息
        if (!localStorage.getItem('tokenFailure')) {
          // 跳转至个人信息页面
          next({ path: '/profileQy' })
          return
        }

      }



      if ((to.path === '/profileQy' || enterPriseVisitor.includes(to.path)) && !userInfo) { // 无个人身份信息 , 且在个人信息页面 
        const code = getQueryVariable('code')

        if (!code) {



          window.location.href = base +
            'wxe2baff2ecd3b76ae' +
            `&redirect_uri=` +
            redirectURL +
            `&response_type=code&scope=snsapi_base&state=qiye&agentId=${1000043}#wechat_redirect`


        } else if (code && getQueryVariable('state') == 'qiye') {

          // 先进行登录 查看身份是否绑定

          const res = await getQyUserInfo(code, 1000043)

          console.log('调用登录接口', res.data, res.code)

          if (res.code === 200 && res.data && res.data.token) {

            res.data.personType = res.data.personType || 2
            localStorage.setItem('userInfo', JSON.stringify(res.data))
            localStorage.setItem('wxCom_token', res.data.token)
            localStorage.setItem('appId', 'wxda773f5504e277d6')
            localStorage.setItem('wxCpUserId', res.data.openId)
            localStorage.removeItem('tokenFailure')
            store.commit('setAppId', 'wxda773f5504e277d6')
            store.commit('setUserId', res.data.loginId)
            store.commit('setSchoolId', res.data.schoolId)
            store.commit('setpId', {
              id: res.data.patriarchUserId,
              schoolId: res.data.patriarchSchoolId,
            })
            // 老师路由集合
            const teacherRoutesPath = [
              '/teacherAttendance',
              '/classesAttendance',
              '/teacherLeaveForm',
              '/approval',
              '/schoolList',
              '/notice-setting',
            ]
            // 学生路由集合
            const studentRoutesPath = [
              '/leaveForm',
              '/studentAttendance',
              '/pickupForm',
              '/openVip',
              '/schoolList',
              '/notice-setting',
            ] // 家长菜单集合


            const userInfo = JSON.parse(localStorage.getItem('userInfo'))
            const redirectPath = '/profile'


            // 家长

            if (studentRoutesPath.indexOf(to.path) > -1) {
              if (userInfo.patriarchSchoolId && userInfo.patriarchUserId) {
                return next()
              } else {
                return next({ path: '/fullscreen' })
              }
            } else if (teacherRoutesPath.indexOf(to.path) > -1) {
              // 正式环境使用这个判断
              if (userInfo.personType == 13 && userInfo.schoolId) {
                return next()
              } else {
                return next({ path: '/fullscreen' })
              }
            } else {
              return next()
            }
          } else if (res.code == '413' && res.msg == '用户未绑定账号') {
            // 未绑定跳转至企业微信授权
            window.location.href = base +
              'wxe2baff2ecd3b76ae' +
              `&redirect_uri=` +
              redirectURL +
              `&response_type=code&scope=snsapi_base&state=qiye2&agentId=${1000043}#wechat_redirect`
          }
        } else if (code && getQueryVariable('state') == 'qiye2') {

          // 微信跳转链接
          window.location.href =
            base +
            'wxda773f5504e277d6' +
            `&redirect_uri=` +
            redirectURL +
            `&response_type=code&scope=snsapi_base&state=${code}#wechat_redirect`

        } else {

          // 微信环境
          localStorage.setItem('code', code)


          const res = await getQyUserInfo(getQueryVariable('state'), 1000043)
          if (res.data.code === 200 && res.data.data && res.data.data.token) {

            res.data.data.personType = res.data.data.personType || 2
            localStorage.setItem('userInfo', JSON.stringify(res.data.data))
            localStorage.setItem('wxCom_token', res.data.data.token)
            localStorage.setItem('appId', 'wxda773f5504e277d6')
            localStorage.removeItem('tokenFailure')
            store.commit('setAppId', 'wxda773f5504e277d6')
            store.commit('setUserId', res.data.loginId)
            store.commit('setSchoolId', res.data.data.schoolId)
            store.commit('setpId', {
              id: res.data.data.patriarchUserId,
              schoolId: res.data.data.patriarchSchoolId,
            })

            // 老师路由集合
            const teacherRoutesPath = [
              '/teacherAttendance',
              '/classesAttendance',
              '/teacherLeaveForm',
              '/approval',
              '/schoolList',
              '/notice-setting',
            ]
            // 学生路由集合
            const studentRoutesPath = [
              '/leaveForm',
              '/studentAttendance',
              '/pickupForm',
              '/openVip',
              '/schoolList',
              '/notice-setting',
            ] // 家长菜单集合


            const userInfo = JSON.parse(localStorage.getItem('userInfo'))
            const redirectPath = '/profile'


            // 家长

            if (studentRoutesPath.indexOf(to.path) > -1) {
              if (userInfo.patriarchSchoolId && userInfo.patriarchUserId) {
                return next()
              } else {
                return next({ path: '/fullscreen' })
              }
            } else if (teacherRoutesPath.indexOf(to.path) > -1) {
              // 正式环境使用这个判断
              if (userInfo.id && userInfo.schoolId) {
                return next()
              } else {
                return next({ path: '/fullscreen' })
              }
            } else {
              return next()
            }

          } else if (res.data.code == '413' && res.data.msg == '用户未绑定账号') {
            next()
          }

        }
        return
      }
      if ((enterPriseVisitor.includes(to.path) && userInfo) || (to.path == '/profileQy' && userInfo)) {  // 处于访客页面并且已绑定或处于个人信息页面并且以绑定,重新登陆判断token是否过期


        // 判断是否是一级页面 ( 获取用户信息测试token是否过期)
        if (from.path == '/') {

          // 原版页面登录获取token方法
          // const code = getQueryVariable('code')

          // if (!code) {


          //   window.location.href = base +
          //     'wxe2baff2ecd3b76ae' +
          //     `&redirect_uri=` +
          //     redirectURL +
          //     `&response_type=code&scope=snsapi_base&state=qiye&agentId=${1000043}#wechat_redirect`

          // } else if (code && getQueryVariable('state') == 'qiye') {



          //   // 先进行登录 查看身份是否绑定
          //   const res = await getQyUserInfo(code, 1000043)
          //   if (res.code === 200 && res.data && res.data.token) {

          //     res.data.personType = res.data.personType || 2
          //     localStorage.setItem('userInfo', JSON.stringify(res.data))
          //     localStorage.setItem('token', res.data.token)
          //     localStorage.setItem('wxCpUserId', res.data.openId)
          //     localStorage.setItem('appId', 'wxda773f5504e277d6')

          //     store.commit('setAppId', 'wxda773f5504e277d6')
          //     store.commit('setUserId', res.data.loginId)
          //     store.commit('setSchoolId', res.data.schoolId)
          //     store.commit('setpId', {
          //       id: res.data.patriarchUserId,
          //       schoolId: res.data.patriarchSchoolId,
          //     })

          //     // 老师路由集合
          //     const teacherRoutesPath = [
          //       '/teacherAttendance',
          //       '/classesAttendance',
          //       '/teacherLeaveForm',
          //       '/approval',
          //       '/schoolList',
          //       '/notice-setting',
          //     ]
          //     // 学生路由集合
          //     const studentRoutesPath = [
          //       '/leaveForm',
          //       '/studentAttendance',
          //       '/pickupForm',
          //       '/openVip',
          //       '/schoolList',
          //       '/notice-setting',
          //     ] // 家长菜单集合


          //     const userInfo = JSON.parse(localStorage.getItem('userInfo'))
          //     const redirectPath = '/profile'


          //     // 家长

          //     if (studentRoutesPath.indexOf(to.path) > -1) {
          //       if (userInfo.patriarchSchoolId && userInfo.patriarchUserId) {
          //         return next()
          //       } else {
          //         return next({ path: '/fullscreen' })
          //       }
          //     } else if (teacherRoutesPath.indexOf(to.path) > -1) {
          //       // 正式环境使用这个判断
          //       if (userInfo.personType == 13 && userInfo.schoolId) {
          //         return next()
          //       } else {
          //         return next({ path: '/fullscreen' })
          //       }
          //     } else {
          //       return next()
          //     }
          //   } else if (res.code == '413' && res.msg == '用户未绑定账号') {
          //     // 清空本地存储
          //     localStorage.clear()
          //     localStorage.setItem('wxCpUserId', res.data)
          //     next({ path: '/profileQy' })
          //     return
          //   }




          // }


          // 获取用户信息判断token是否过期
          const wxCpUserId = localStorage.getItem('wxCpUserId')
          const res = await getQyNewUserInfo(wxCpUserId)
          console.log('获取企业登录信息', res)
          const info = res.data
          if (res.code == 200) {
            localStorage.setItem('userInfo', JSON.stringify({
              ...JSON.parse(localStorage.getItem('userName')),
              ...info
            }))
          } else {
            localStorage.removeItem('userInfo')
            localStorage.removeItem('wxCom_token')
            localStorage.setItem('tokenFailure', 'tokenFailure')
            Vue.prototype.$toast('获取信息失败，请重新登录')
            return
          }


          // 老师路由集合
          const teacherRoutesPath = [
            '/teacherAttendance',
            '/classesAttendance',
            '/teacherLeaveForm',
            '/approval',
            '/schoolList',
            '/notice-setting',
          ]
          // 学生路由集合
          const studentRoutesPath = [
            '/leaveForm',
            '/studentAttendance',
            '/pickupForm',
            '/openVip',
            '/schoolList',
            '/notice-setting',
          ] // 家长菜单集合


          const userInfo = JSON.parse(localStorage.getItem('userInfo'))
          const redirectPath = '/profile'

          // 家长

          if (studentRoutesPath.indexOf(to.path) > -1) {
            if (userInfo.patriarchSchoolId && userInfo.patriarchUserId) {
              return next()
            } else {
              return next({ path: '/fullscreen' })
            }
          } else if (teacherRoutesPath.indexOf(to.path) > -1) {
            // 正式环境使用这个判断
            if (userInfo.personType == 13 && userInfo.schoolId) {
              return next()
            } else {
              return next({ path: '/fullscreen' })
            }
          } else {
            return next()
          }

        } else {
          // 老师路由集合
          const teacherRoutesPath = [
            '/teacherAttendance',
            '/classesAttendance',
            '/teacherLeaveForm',
            '/approval',
            '/schoolList',
            '/notice-setting',
          ]
          // 学生路由集合
          const studentRoutesPath = [
            '/leaveForm',
            '/studentAttendance',
            '/pickupForm',
            '/openVip',
            '/schoolList',
            '/notice-setting',
          ] // 家长菜单集合


          const userInfo = JSON.parse(localStorage.getItem('userInfo'))
          const redirectPath = '/profile'


          // 家长

          if (studentRoutesPath.indexOf(to.path) > -1) {
            if (userInfo.patriarchSchoolId && userInfo.patriarchUserId) {
              return next()
            } else {
              return next({ path: '/fullscreen' })
            }
          } else if (teacherRoutesPath.indexOf(to.path) > -1) {
            // 正式环境使用这个判断
            if (userInfo.personType == 13 && userInfo.schoolId) {
              return next()
            } else {
              return next({ path: '/fullscreen' })
            }
          } else {
            return next()
          }
        }



      }




    }

  }
})



export default router
